import {
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceLength3278n89t01tmv as charSequenceLength,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  toString22rbkbhdb5cl2 as toString,
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixdnyockrdnmht5 as Char__toInt_impl_vasixd,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  copyOf3rutauicler23 as copyOf,
  copyOf2ng0t8oizk6it as copyOf_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { toByte4i43936u611k as toByte } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { JsonScope_instance394helby6dhwe as JsonScope_instance } from './internal/JsonScope.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  isNaNymqb93xtq8w8 as isNaN_0,
  isInfinite12nl8hpz1hbp2 as isInfinite,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { IOException3fje1ukjwthwb as IOException } from '../../../../../../okio-parent-okio/okio/NonJvmPlatform.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function hexString($this, $receiver) {
  var value = $receiver;
  return toString(charCodeAt('0123456789abcdef', value >>> 4 | 0)) + toString(charCodeAt('0123456789abcdef', value & 15));
}
function _get_separator__ee6j2k($this) {
  var tmp;
  // Inline function 'kotlin.text.isNullOrEmpty' call
  var this_0 = $this.p4a_1;
  if (this_0 == null || charSequenceLength(this_0) === 0) {
    tmp = ':';
  } else {
    tmp = ': ';
  }
  return tmp;
}
function open($this, empty, openBracket) {
  beforeValue($this);
  pushScope($this, empty);
  $this.t4a_1[$this.q4a_1 - 1 | 0] = 0;
  $this.o4a_1.p3z(openBracket);
  return $this;
}
function close($this, empty, nonempty, closeBracket) {
  var context = peekScope($this);
  // Inline function 'kotlin.check' call
  if (!!(!(context === nonempty) && !(context === empty))) {
    var message = 'Nesting problem.';
    throw IllegalStateException().o(toString_0(message));
  }
  // Inline function 'kotlin.check' call
  if (!($this.u4a_1 == null)) {
    var message_0 = 'Dangling name: ' + $this.u4a_1;
    throw IllegalStateException().o(toString_0(message_0));
  }
  $this.q4a_1 = $this.q4a_1 - 1 | 0;
  $this.s4a_1[$this.q4a_1] = null;
  var _array__4zh2yp = $this.t4a_1;
  var _index_0__fvwizt = $this.q4a_1 - 1 | 0;
  _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] + 1 | 0;
  if (context === nonempty) {
    newline($this);
  }
  $this.o4a_1.p3z(closeBracket);
  return $this;
}
function writeDeferredName($this) {
  if (!($this.u4a_1 == null)) {
    beforeName($this);
    Companion_getInstance().x4a($this.o4a_1, ensureNotNull($this.u4a_1));
    $this.u4a_1 = null;
  }
}
function newline($this) {
  if ($this.p4a_1 == null) {
    return Unit_instance;
  }
  // Inline function 'kotlin.code' call
  var this_0 = _Char___init__impl__6a9atx(10);
  var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
  $this.o4a_1.r3z(tmp$ret$0);
  var i = 1;
  var size = $this.q4a_1;
  while (i < size) {
    $this.o4a_1.p3z($this.p4a_1);
    i = i + 1 | 0;
  }
}
function beforeName($this) {
  var context = peekScope($this);
  if (context === 5) {
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(44);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    $this.o4a_1.r3z(tmp$ret$0);
  } else {
    // Inline function 'kotlin.check' call
    if (!(context === 3)) {
      var message = 'Nesting problem.';
      throw IllegalStateException().o(toString_0(message));
    }
  }
  newline($this);
  replaceTop($this, 4);
}
function beforeValue($this) {
  switch (peekScope($this)) {
    case 7:
      throw IllegalStateException().o('JSON must have only one top-level value.');
    case 6:
      replaceTop($this, 7);
      break;
    case 1:
      replaceTop($this, 2);
      newline($this);
      break;
    case 2:
      // Inline function 'kotlin.code' call

      var this_0 = _Char___init__impl__6a9atx(44);
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      $this.o4a_1.r3z(tmp$ret$0);
      newline($this);
      break;
    case 4:
      $this.o4a_1.p3z(_get_separator__ee6j2k($this));
      replaceTop($this, 5);
      break;
    default:
      throw IllegalStateException().o('Nesting problem.');
  }
}
function peekScope($this) {
  // Inline function 'kotlin.check' call
  if (!!($this.q4a_1 === 0)) {
    var message = 'JsonWriter is closed.';
    throw IllegalStateException().o(toString_0(message));
  }
  return $this.r4a_1[$this.q4a_1 - 1 | 0];
}
function pushScope($this, newTop) {
  if ($this.q4a_1 === $this.r4a_1.length) {
    $this.r4a_1 = copyOf($this.r4a_1, imul($this.r4a_1.length, 2));
    $this.s4a_1 = copyOf_0($this.s4a_1, imul($this.s4a_1.length, 2));
    $this.t4a_1 = copyOf($this.t4a_1, imul($this.t4a_1.length, 2));
  }
  var tmp = $this.r4a_1;
  var _unary__edvuaz = $this.q4a_1;
  $this.q4a_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = newTop;
}
function replaceTop($this, topOfStack) {
  $this.r4a_1[$this.q4a_1 - 1 | 0] = topOfStack;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.v4a_1 = '0123456789abcdef';
        var tmp = this;
        // Inline function 'kotlin.arrayOfNulls' call
        // Inline function 'kotlin.apply' call
        var this_0 = Array(128);
        var inductionVariable = 0;
        if (inductionVariable <= 31)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this_0[i] = '\\u00' + hexString(Companion_getInstance(), toByte(i));
          }
           while (inductionVariable <= 31);
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(34);
        this_0[Char__toInt_impl_vasixd(this_1)] = '\\"';
        // Inline function 'kotlin.code' call
        var this_2 = _Char___init__impl__6a9atx(92);
        this_0[Char__toInt_impl_vasixd(this_2)] = '\\\\';
        // Inline function 'kotlin.code' call
        var this_3 = _Char___init__impl__6a9atx(9);
        this_0[Char__toInt_impl_vasixd(this_3)] = '\\t';
        // Inline function 'kotlin.code' call
        var this_4 = _Char___init__impl__6a9atx(8);
        this_0[Char__toInt_impl_vasixd(this_4)] = '\\b';
        // Inline function 'kotlin.code' call
        var this_5 = _Char___init__impl__6a9atx(10);
        this_0[Char__toInt_impl_vasixd(this_5)] = '\\n';
        // Inline function 'kotlin.code' call
        var this_6 = _Char___init__impl__6a9atx(13);
        this_0[Char__toInt_impl_vasixd(this_6)] = '\\r';
        tmp.w4a_1 = this_0;
      }
      x4a(sink, value) {
        var replacements = this.w4a_1;
        // Inline function 'kotlin.code' call
        var this_0 = _Char___init__impl__6a9atx(34);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        sink.r3z(tmp$ret$0);
        var last = 0;
        var length = value.length;
        var inductionVariable = 0;
        if (inductionVariable < length)
          $l$loop_0: do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var c = charCodeAt(value, i);
            var replacement;
            // Inline function 'kotlin.code' call
            if (Char__toInt_impl_vasixd(c) < 128) {
              // Inline function 'kotlin.code' call
              replacement = replacements[Char__toInt_impl_vasixd(c)];
              if (replacement == null) {
                continue $l$loop_0;
              }
            } else {
              if (c === _Char___init__impl__6a9atx(8232)) {
                replacement = '\\u2028';
              } else {
                if (c === _Char___init__impl__6a9atx(8233)) {
                  replacement = '\\u2029';
                } else {
                  continue $l$loop_0;
                }
              }
            }
            if (last < i) {
              sink.q3z(value, last, i);
            }
            sink.p3z(replacement);
            last = i + 1 | 0;
          }
           while (inductionVariable < length);
        if (last < length) {
          sink.q3z(value, last, length);
        }
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(34);
        var tmp$ret$3 = Char__toInt_impl_vasixd(this_1);
        sink.r3z(tmp$ret$3);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var BufferedSinkJsonWriterClass;
function BufferedSinkJsonWriter() {
  if (BufferedSinkJsonWriterClass === VOID) {
    class $ {
      constructor(sink, indent) {
        Companion_getInstance();
        indent = indent === VOID ? null : indent;
        this.o4a_1 = sink;
        this.p4a_1 = indent;
        this.q4a_1 = 0;
        this.r4a_1 = new Int32Array(64);
        var tmp = this;
        // Inline function 'kotlin.arrayOfNulls' call
        tmp.s4a_1 = Array(64);
        this.t4a_1 = new Int32Array(64);
        this.u4a_1 = null;
        pushScope(this, 6);
      }
      y4a() {
        return joinToString(JsonScope_instance.h4b(this.q4a_1, this.r4a_1, this.s4a_1, this.t4a_1), '.');
      }
      w41() {
        writeDeferredName(this);
        return open(this, 1, '[');
      }
      x41() {
        return close(this, 1, 2, ']');
      }
      r41() {
        writeDeferredName(this);
        return open(this, 3, '{');
      }
      s41() {
        return close(this, 3, 5, '}');
      }
      t48(name) {
        // Inline function 'kotlin.check' call
        if (!!(this.q4a_1 === 0)) {
          var message = 'JsonWriter is closed.';
          throw IllegalStateException().o(toString_0(message));
        }
        // Inline function 'kotlin.check' call
        if (!(this.u4a_1 == null)) {
          var message_0 = 'Nesting problem.';
          throw IllegalStateException().o(toString_0(message_0));
        }
        this.u4a_1 = name;
        this.s4a_1[this.q4a_1 - 1 | 0] = name;
        return this;
      }
      d42(value) {
        writeDeferredName(this);
        beforeValue(this);
        Companion_getInstance().x4a(this.o4a_1, value);
        var _array__4zh2yp = this.t4a_1;
        var _index_0__fvwizt = this.q4a_1 - 1 | 0;
        _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] + 1 | 0;
        return this;
      }
      w40() {
        return this.i4b('null');
      }
      n42(value) {
        return this.i4b(value ? 'true' : 'false');
      }
      i42(value) {
        // Inline function 'kotlin.require' call
        if (!(!isNaN_0(value) && !isInfinite(value))) {
          var message = 'Numeric values must be finite, but was ' + value;
          throw IllegalArgumentException().n2(toString_0(message));
        }
        return this.i4b(value.toString());
      }
      f42(value) {
        return this.i4b(value.toString());
      }
      l42(value) {
        return this.i4b(value.toString());
      }
      j4b(value) {
        return this.i4b(value.k4b_1);
      }
      s42(value) {
        // Inline function 'kotlin.apply' call
        this.w40();
        return this;
      }
      i4b(value) {
        writeDeferredName(this);
        beforeValue(this);
        this.o4a_1.p3z(value);
        var _array__4zh2yp = this.t4a_1;
        var _index_0__fvwizt = this.q4a_1 - 1 | 0;
        _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] + 1 | 0;
        return this;
      }
      l6() {
        this.o4a_1.l6();
        var size = this.q4a_1;
        if (size > 1 || (size === 1 && !(this.r4a_1[size - 1 | 0] === 7))) {
          throw IOException().e40('Incomplete document');
        }
        this.q4a_1 = 0;
      }
    }
    initMetadataForClass($, 'BufferedSinkJsonWriter');
    BufferedSinkJsonWriterClass = $;
  }
  return BufferedSinkJsonWriterClass;
}
//region block: exports
export {
  BufferedSinkJsonWriter as BufferedSinkJsonWriter1xl4ankftitqq,
};
//endregion

//# sourceMappingURL=BufferedSinkJsonWriter.mjs.map
